export const appLightboxImage = {
    create: function(){
        var that = this;
        if($('[data-lbi="true"]').length){
            that.bindEvents();
        }
    },
    bindEvents: function(){
        var that = this;
        $(document).on('click', '[data-lbi="true"]', function(){
            var lbSrc = $(this).attr('data-lbsrc'),
                lbTxt = $(this).attr('data-lbtxt');
            that.openLightbox(lbSrc, lbTxt);
        });
        $(document).on('click', '.js-ilb-close', function(e){
            e.preventDefault();
            $('.js-imglb-overlay').remove();
            $('body').removeClass('no-scroll');
        });
    },
    openLightbox: function(lbSrc, lbTxt){
        var that = this,
            lightboxMarkup = '<div class="image-lightbox-overlay js-imglb-overlay"><div class="ilb-overlay-top"><div class="ilb-close"><a aria-label="Schließen button" class="close-button js-ilb-close" href="#"><svg aria-hidden="true"><use xlink:href="/images/frontend/main-icons.svg#close-icon"></use></svg></a></div></div><div class="ilb-output"><img src="' + lbSrc + '" alt="' + lbTxt + '"/></div><div class="ilb-text">' + lbTxt + '</div></div>';
        $('body').append($(lightboxMarkup));
        $('body').addClass('no-scroll');
    }
}
